import { entries, groupBy, sumBy } from 'lodash'

import { TransportType } from '@freighthub/freighthub-corelib'

import { BookingDTOTransportType, TransportUnitDTO } from '@/clients/booking'

import { containerTypeGroupTerms, isValidContainerType } from '../domain/containerGroupTerms'

const formatContainerTypeCount = (quantity: number, type: string) => {
  const typeName = isValidContainerType(type) ? containerTypeGroupTerms[type] : type
  return `${quantity} x ${typeName}`
}

export const formatFCLContainerTypes = (units: TransportUnitDTO[]) => {
  const containersGroupedByContainerType = groupBy(units, 'type')
  return entries(containersGroupedByContainerType)
    .map(([type, groupedContainers]) =>
      formatContainerTypeCount(
        sumBy(groupedContainers, (containerItem) => containerItem.quantity),
        type
      )
    )
    .join(', ')
}

const formatFCLTransportUnits = (units: TransportUnitDTO[]): string => {
  return formatFCLContainerTypes(units)
}

export const unitVolume = (unit: TransportUnitDTO): number => {
  if (unit.dimensions == null || !unit.dimensions.heightCm || !unit.dimensions.lengthCm || !unit.dimensions.widthCm) {
    return 0
  }
  return (unit.dimensions.heightCm * unit.dimensions.lengthCm * unit.dimensions.widthCm) / 1000000
}

const formatLCLTransportUnits = (cargo: TransportUnitDTO[]): string => {
  const volume = sumBy(cargo, (unit) => unitVolume(unit))

  const totalQuantity = sumBy(cargo, (unit) => unit.quantity || 0)

  return `${totalQuantity} x ${volume.toFixed(2)}cbm`
}

export const formatEquipment = (transportType: TransportType, cargo: TransportUnitDTO[]): string => {
  if (transportType === BookingDTOTransportType.Lcl) {
    return formatLCLTransportUnits(cargo)
  }
  return formatFCLTransportUnits(cargo)
}

export const formatCmToM = (cm: number): string => {
  return `${(cm / 100).toFixed(2)} m`
}
